// src/pages/traduccion_especializada.js

import React from "react";
import Header from '../../components/Header'
import Footer from '../../components/Footer'

function TraduccionUrgente() {
    return (
        <>
            <Header />
            {/* CABECERA */}
            <section className="p__cabecera" id="inicio">
                <div className="wrap text-center">
                    <h1>Traducción Urgente</h1>
                    <p>
                        Expertos en cada área que garantizan la precisión
                        terminológica.
                    </p>
                </div>
            </section>

            {/* SERVICIO */}
            <section className="empresa" id="empresa">
                <div className="wrap">

                    {/* ESCRITORIO */}
                    <div className="emp3" style={{ padding: "50px" }}>
                        <ul className="mt-3">
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-circle-check"></i>
                                <span> Servicio de traducción rápida y precisa para documentos o trámites con entrega express y atención prioritaria.</span>
                            </li>
                        </ul>


                    </div>
                    <div className="emp4" style={{ padding: "50px" }}>
                        {/* <h3 className="text-left eyebrow font-bold" style={{ fontSize: "24px" }}>Documentos:</h3> */}
                        <ul className="mt-3">
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Nuestro valor agregado es que contamos con expertos en cada área que garantizan y revisan la precisión terminológica.</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default TraduccionUrgente;